const ACCESS_KEY = 'user_partner_access';
const CONTEXT_KEY = 'selected_partner_context';
const SWITCH_BRAND_KEY = 'switch_brand_requested';
const NAV_STATE_KEY = 'partner_nav_state';

export const PARTNER_NAV_STATES = {
    NONE: 'none',
    SELECTING: 'selecting',
};

export function saveUserAccess(access) {
    localStorage.setItem(ACCESS_KEY, JSON.stringify(access ?? []));
}

export function getUserAccess() {
    try {
        const data = localStorage.getItem(ACCESS_KEY);
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
}

export function savePartnerContext(partnerId, group) {
    const context = { partner_id: partnerId, group };
    localStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
}

export function getPartnerContext() {
    try {
        const data = localStorage.getItem(CONTEXT_KEY);
        return data ? JSON.parse(data) : null;
    } catch {
        return null;
    }
}

export function setSwitchBrandRequested(value = true) {
    localStorage.setItem(SWITCH_BRAND_KEY, value ? '1' : '0');
}

export function consumeSwitchBrandRequested() {
    try {
        const value = localStorage.getItem(SWITCH_BRAND_KEY) === '1';
        localStorage.removeItem(SWITCH_BRAND_KEY);
        return value;
    } catch {
        return false;
    }
}

export function setPartnerNavState(state) {
    localStorage.setItem(NAV_STATE_KEY, state);
}

export function getPartnerNavState() {
    return localStorage.getItem(NAV_STATE_KEY) || PARTNER_NAV_STATES.NONE;
}

export function clearPartnerNavState() {
    localStorage.removeItem(NAV_STATE_KEY);
}
